module.exports = __webpack_public_path__ + "static/media/corporateStep2.2c01aaac.svg";